(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("cssLoaderService", CSSLoaderService);

    CSSLoaderService.$inject = ['$q', 'localize', 'hTransitions'];

    function CSSLoaderService($q, localize, hTransitions) {
        var self = this;

        self.activeFramework = undefined;
        var pathsToDelete = [];

        var unhookTransitionSuccess = hTransitions.onSuccess({}, function (trans) {
            trans.promise
                .finally(function () {
                    if (pathsToDelete && pathsToDelete.length) {
                        for (var i in pathsToDelete) {
                            $(pathsToDelete[i].element).remove();
                            delete pathsToDelete[i].element;
                        }
                        pathsToDelete = [];
                    }
                });
        });

        var injectCSS = function (cssContent, priority) {

            var scriptElm = document.createElement('style');
            scriptElm.setAttribute('type', 'text/css');

            if (scriptElm.styleSheet) {   // IE
                scriptElm.styleSheet.cssText = cssContent;
            } else {
                scriptElm.appendChild(document.createTextNode(cssContent));
            }

            var bodySelector = $("body");
            if (self.activeFramework === 'bootstrap_v3') {
                bodySelector.hasClass('bs4') && bodySelector.removeClass('bs4');
                !bodySelector.hasClass('bs3') &&  bodySelector.addClass('bs3');
            } else {
                bodySelector.hasClass('bs3') && bodySelector.removeClass('bs3');
                !bodySelector.hasClass('bs4') &&  bodySelector.addClass('bs4');
            }

            if (priority === PRIORITY.HIGH) {
                $("head").prepend(scriptElm);
            }
            else {
                $("body").append(scriptElm);
            }

            return scriptElm;
        };

        var bindStylesToDOM = function (pathsToLoad) {
            pathsToDelete = [];

            for (var path in cache) {
                var cachedPath = cache[path];

                var foundPath = pathsToLoad.find(function (item) {
                    return item['path'] === path;
                });

                if (foundPath) {
                    if (!cachedPath.element && cachedPath.result) {
                        var element = injectCSS(cachedPath.result, cachedPath.priority);
                        cachedPath.element = element;
                    }
                }
                else if (cachedPath.element) {
                    pathsToDelete.push(cachedPath);
                }
            }
        };

        var getStylePath = function (nameOrPath) {
            var stylePath = cssMap[nameOrPath] || nameOrPath;

            if (stylePath.indexOf('../wp-pages') === -1 && stylePath.indexOf('../') === 0) {
                stylePath = stylePath.replace("../", ".tmp/styles/");
            }

            return stylePath;
        };

        var loadStylePath = function (pathObj) {
            var defer = $q.defer();
            var path = pathObj.path;

            if (!cache[path]) {
                cache[path] = {result: undefined, waiting: []};
            }

            if (typeof(cache[path]['result']) === 'undefined') {
                if (cache[path].waiting.length === 0) {
                    $.get(path)
                        .done(function (result) {
                            cache[path].result = result;
                            cache[path].priority = pathObj.priority || PRIORITY.NORMAL;

                            delete cache[path].error;
                        })
                        .fail(function (err) {
                            cache[path].result = undefined;
                            cache[path].error = err;
                        })
                        .always(function () {
                            for (var i in cache[path].waiting) {
                                cache[path].waiting[i].resolve();
                            }
                        });
                }

                cache[path].waiting.push(defer);
            }
            else {
                defer.resolve();
            }

            return defer.promise;
        };

        self.load = function (routeStyles, doNotInject) {
            var defer = $q.defer();

            doNotInject = !!doNotInject;
            routeStyles = routeStyles || {};

            var framework = routeStyles.framework || 'bootstrap_v4';
            var styles = routeStyles.styles || [];

            if (localize.isRTL() && framework === 'bootstrap_v4') {
                framework = 'bootstrap_v4_rtl';
            }

            self.activeFramework = framework;

            var pathsToLoad = [{path: FRAMEWORKS[framework], priority: PRIORITY.HIGH}];

            for (var i in styles) {
                pathsToLoad.push((function(){
                    var style = styles[i], d = $q.defer(), hUser = $injector.get("hUser");
                    if (style.indexOf('UK:') > -1) {
                        var UKOnlyStyle = style.indexOf('!UK:') === -1;
                        hUser.isFromUK().then(function (isUK) {
                            if (isUK && UKOnlyStyle || !isUK && !UKOnlyStyle) {
                                // remove UK prefix
                                var styleMapName = style.substr(style.indexOf(":") + 1);
                                d.resolve({path: getStylePath(styleMapName), priority: PRIORITY.NORMAL});
                            } else {
                                d.resolve({skip: true});
                            }
                        });
                    } else {
                        d.resolve({path: getStylePath(styles[i]), priority: PRIORITY.NORMAL});
                    }

                    return d.promise;
                })());
            }

            $q.all(pathsToLoad).then(function(pathsToLoadRes){
                var promises = [];

                for (var i in pathsToLoadRes) {
                    if(!pathsToLoadRes[i].skip){
                        promises.push(loadStylePath(pathsToLoadRes[i]));
                    }
                }

                $q.all(promises).finally(function () {
                    if (!doNotInject) {
                        bindStylesToDOM(pathsToLoadRes);
                    }

                    defer.resolve(doNotInject && function () {
                        bindStylesToDOM(pathsToLoadRes);
                    });
                });
            });


            return defer.promise;
        }
    };


    var cache = {};

    var FRAMEWORKS = {
        "bootstrap_v3": "../node_modules/bootstrap/dist/css/bootstrap.css",
        "bootstrap_v4": "../node_modules/bootstrap-v4-rtl/dist/css/bootstrap.min.css",
        "bootstrap_v4_rtl": "../styles/harri-rtl.css"
    };

    var PRIORITY = {
        NORMAL: 'normal',
        HIGH: 'high'
    };

})();
